export const mapChannels = (channels) => {
    const channelsMap = {};
    channels.forEach((channel) => {
        channelsMap[channel.station_id] = {
            id: channel.station_id,
            displayName: channel.display_name,
            stationId: channel.station_id,
            callSign: channel.call_sign,
            type: channel.type,
            category: channel.category,
            networkType: channel.network_type,
            name: channel.station_name,
            logoOnDark: channel.logo_on_dark_uri,
            logoOnWhite: channel.logo_on_white_uri,
            tags: [...new Set(channel.tags)], // removes duplicated tags - happens for some channels
        };
    });
    return channelsMap;
};
